import { Injectable } from '@angular/core';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GlobalMessage, GlobalMessageActions, TranslationService } from '@spartacus/core';
import { filter, map, take, tap } from 'rxjs/operators';

@Injectable()
export class GlobalMessageEffect {
  globalMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GlobalMessageActions.ADD_MESSAGE),
        map(({ payload }) => payload),
        filter(
          (message: GlobalMessage) =>
            message.text && !['httpHandlers.cartNotFound', 'httpHandlers.forbidden'].includes(message.text?.key),
        ),
        tap(({ text }: GlobalMessage) => {
          this.translationService
            .translate(text.key, text.params)
            .pipe(
              take(1),
              filter((value) => !!value && !!value.trim()),
            )
            .subscribe((translatedText) => {
              if (text.raw) {
                translatedText = text.raw;
              }
              this.snackbarFacade.setSnack({
                text: translatedText,
                theme: SnackTheme.Yellow,
              });
            });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private translationService: TranslationService,
    private snackbarFacade: SnackbarFacade,
  ) {}
}
